import React from 'react';
import { FileText } from 'lucide-react';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3">
            <div className="bg-[rgba(255,127,50,0.1)] rounded-full p-3">
              <FileText className="w-8 h-8 text-[#FF7F32]" />
            </div>
            <h1 className="text-3xl font-black italic text-[#061970] uppercase tracking-tight">
              Aviso de Privacidad: MRC
            </h1>
          </div>

          {/* Content */}
          <div className="space-y-6 text-[#4a5565] text-lg leading-relaxed">
            <p>
              En <span className="font-semibold">MRC</span>, valoramos la confianza que depositas en nosotros al elegir nuestra protección en movimiento. Por ello, nos comprometemos a resguardar tus datos personales con los más altos estándares de seguridad.
            </p>

            <div>
              <h2 className="font-semibold text-xl mb-2">1. Datos que Recabamos</h2>
              <p>
                Para ofrecerte una mejor experiencia y soporte técnico sobre nuestros cascos, no recabamos información de ninguna persona, manteniendo tus datos seguros.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-xl mb-2">2. Transferencia de Datos a Terceros</h2>
              <p>
                Te informamos que <span className="font-semibold">MRC</span> no vende ni renta tus datos personales. Al ser un showroom digital, nuestro sitio redirige a distribuidores oficiales como Elektra e Italika. No obstante, <span className="font-semibold">MRC</span> no comparte tus datos personales con dichos terceros; cualquier información que proporciones en sus sitios web estará sujeta a sus propios avisos de privacidad.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
